import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getUser = () => {
  const str = localStorage.getItem('user')
  if (!str) return {}
  const user = JSON.parse(str)
  // if (new Date(user.token_expire_at.replace(/-/gi, '/')).getTime() < Date.now()) {
  //   localStorage.removeItem('user')
  //   return {}
  // }
  return user
}

export default new Vuex.Store({
  state: {
    user: getUser()
  },
  mutations: {
    updateState (state, payload) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js